export default __webpack_public_path__ + "static/media/tokenPool.16dd4a5e.jpg";